export class BulkRestoreResponseItemsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "BulkRestoreItemStatus",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "resolvedSnapshotId",
            "baseName": "resolvedSnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resolvedPointInTime",
            "baseName": "resolvedPointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "earliestAvailable",
            "baseName": "earliestAvailable",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "templateId",
            "baseName": "templateId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resolvedTargetAccountId",
            "baseName": "resolvedTargetAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resolvedResourceType",
            "baseName": "resolvedResourceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "resolvedSnapshotHasThreatFindings",
            "baseName": "resolvedSnapshotHasThreatFindings",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resolvedVaultId",
            "baseName": "resolvedVaultId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreResponseItemsInner.attributeTypeMap;
    }
    constructor() {
    }
}
